import uniq from 'lodash/uniq';

export const removeNoticesBasedOnTypeAndTitle = ({ noticesTypeToRemove, keysToRemove, notices, removeNotice }) => {
  if (typeof removeNotice !== 'function') {
    console.warn('Invalid value provided for removeNotice');
    return;
  }

  if (notices?.length && keysToRemove?.length && noticesTypeToRemove) {
    let noticesIdsToRemove = [];
    notices.forEach(item => {
      if (
        item?.type === noticesTypeToRemove &&
        keysToRemove.some(keyword => item?.title?.toLowerCase()?.includes(keyword))
      ) {
        noticesIdsToRemove.push(item.id);
      }
    })

    if (noticesIdsToRemove.length) {
      uniq(noticesIdsToRemove).forEach(removeNotice);
    }
  }
}
